import { useEffect, useState } from 'react';
import jwt from 'jsonwebtoken';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import Cookies from 'universal-cookie';
import KeycloakService from '../services/keycloak-service';

import * as authService from '../services/auth';

export default function SsoLogin() {
  const navigate = useNavigate();
  const [keycloackInitialized, setKeycloakInitialized] = useState(false);
  const cookies = new Cookies();

  useEffect(() => {
    KeycloakService.initKeycloak(async () => {
      const token = KeycloakService.getToken();
      const decode = jwt.decode(token);

      try {
        const result = await authService.compare({ username: decode.preferred_username });
        const path = ['DEVELOPMENT', 'STAGING'].includes(process.env.REACT_APP_STAGE) ? '/' : '/';
        cookies.set('token', result.token, { path });
        navigate('/dashboard', { replace: true });
      } catch (error) {
        toast.error('Maaf, user tidak ditemukan');
        KeycloakService.logout();
      }
      setKeycloakInitialized(true);
    });
  }, []);

  if (!keycloackInitialized) {
    return <div>Loading...</div>;
  }
  return null;
}
